import React, { useState, useEffect  } from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import UISelect from 'components/selectbox/UISelect';
import { CodeData } from "common/codedata/source/CodeDataSource";
function ContentsContainer() {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [searchText,setSearchText] = useState('');
	const [divCd,setDivCd] = useState('01');
	const [ApprovalLine, setApprovalLine] = useState('');
	const [ApprovalLine_S, setApprovalLine_S] = React.useState<CodeData[]>();
	const [SAN_NM, setSAN_NM] = useState('');
	const [REG_PERSON_ID, setREG_PERSON_ID] = useState('');
	const [REG_PERSON_NM, setREG_PERSON_NM] = useState('');
	const [REG_LOGIN_NM, setREG_LOGIN_NM] = useState('');
	const [APPR_ID, setAPPR_ID] = useState('');	
	

	let LeftSheetData = {};
	let RightSheetData = {};
	
	var ib_modal = ib_modal||{};
 	ib_modal = {
		//시트 초기화 구문
		'init':{
			"LeftSheetInit": {
				//공통기능 설정 부분
				"Cfg": {
		            "SearchMode": 0,
		            "CanSort": true,
		            "CanColMove": false,
		            "CanColResize": false,
		            "Height": "390px",
		            "InfoRowConfig": {
		                "Visible": false
		            },
				},
				//중앙(메인) 컬럼 설정
			    "Cols": [
					{"Header": "이름",	"Type": "Text","Name": "PERSON_NM",		"Align": "Center",	"CanEdit": 0,"RelWidth": 1},
					{"Header": "직급",	"Type": "Text","Name": "POSI_NM",		"Align": "Center",	"CanEdit": 0,"RelWidth": 1},
					{"Header": "부서",	"Type": "Text","Name": "DEPT_NM",		"Align": "left",	"CanEdit": 0,"RelWidth": 1.5},
					{"Header": "아이디",	"Type": "Text","Name": "LOGIN_NM",		"Align": "left",	"CanEdit": 0,"RelWidth": 1},
					{"Header": "LIMIT_AMOUNT",	"Type": "Text","Name": "LIMIT_AMOUNT",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "AMOUNT_RANGE",	"Type": "Text","Name": "AMOUNT_RANGE",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "PERSON_ID",		"Type": "Text","Name": "PERSON_ID",		"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{
						"Header": "담당",
						"Type": "Enum",
						"Name": "APPROVAL_ROLE", 
						"RelWidth": 1,
						"Required": 1,
						"CanEdit": 1,
						"IconAlign": "Center",
						"Enum": "|검토자|협조자|감사자|결재자",
						"EnumKeys": "|1|2|3|4",
						Visible : 0
					}					
				]
			},
			"RightSheetInit": {
				"Cfg": {
		            
		            "SearchMode": 0,
		            "CanSort": false,
		            "CanColMove": false,
		            "CanColResize": false,
		            "Height": "280px",
		            "InfoRowConfig": {
		                "Visible": false
		            },
		            "ZIndex": 900, //결재선 프레임 zindex가 900입니다. 그 이상 설정해주어야 합니다.
            
				},
			    
				"Cols": [
					{"Header": "이름",	"Type": "Text","Name": "PERSON_NM",		"Align": "Center",	"CanEdit": 0,	"RelWidth": 1},
					{"Header": "직급",	"Type": "Text","Name": "POSI_NM",		"Align": "Center",	"CanEdit": 0,	"RelWidth": 1},
					{"Header": "부서",	"Type": "Text","Name": "DEPT_NM",		"Align": "left",	"CanEdit": 0,	"RelWidth": 1.5},
					{"Header": "아이디",	"Type": "Text","Name": "LOGIN_NM",		"Align": "let",	"CanEdit": 0,	"RelWidth": 1},
					{"Header": "LIMIT_AMOUNT",	"Type": "Text","Name": "LIMIT_AMOUNT",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "AMOUNT_RANGE",	"Type": "Text","Name": "AMOUNT_RANGE",	"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{"Header": "PERSON_ID",		"Type": "Text","Name": "PERSON_ID",		"CanEdit": 0,"RelWidth": 1, Visible : 0},
					{
						"Header": {"Value": "담당" ,"Color": "#FFDFDF"},	
						"Type": "Enum",
						"Name": "APPROVAL_ROLE", 
						"RelWidth": 1,
						"Required": 1,
						"CanEdit": 1,
						"IconAlign": "Center",
						"Enum": "|검토자|협조자|감사자|결재자",
						"EnumKeys": "|1|2|3|4"
					}
				]
			}     

		},
		//시트 이벤트
		'event':{

			onAfterRowMoveToSheet:function (evtParam) {
				console.log('onAfterRowMoveToSheet 이벤트 발생:\n' + evtParam.sheet.id + '시트에서 ' + evtParam.tosheet.id + '로 행이 이동하였습니다.');
			},
			  onRenderFirstFinish:function (evtParam) {
					//초기 데이터 로딩
					initSheet_modal();
			},
			onAfterRowCopy:function(evtParam){
				if(evtParam.source.Deleted === true) {
					alert('지워진 행은 복사할 수 없습니다.');
					//evtParam.sheet.showMessageTime('지워진 행은 복사할 수 없습니다.', 800);
					return true;
				}
			},
			onDblClick:function(evtParam){     //더블 클릭시 행 카피 가능하게 처리
				var sheet = evtParam.sheet;
				if(sheet.id === "LeftSheet"){     //왼쪽 시트일경우만 copy가능
					/** 행 추가 전에 중복 데이터 확인 처리 */
					//@ts-ignore
					if(RightSheet.getTotalRowCount() > 6){
						UIUtils.alert('최대 7명까지만 결재순위에 등록할 수 있습니다.').then();
						//evtParam.sheet.showMessageTime(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다.', 800);
						return;						
					}
					//@ts-ignore
					if(RightSheet.getTotalRowCount() > 0){
						//@ts-ignore
						var rightRows = RightSheet.getDataRows(); //우측 시트값 전체 데이터 조회
						//@ts-ignore
						var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
						fRows.APPROVAL_ROLE = 1;
						for(var i=0; i<rightRows.length; i++){
							if(fRows.PERSON_NM === rightRows[i].PERSON_NM){
								//alert(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다');
								UIUtils.alert('중복이름이 존재합니다').then();
								//evtParam.sheet.showMessageTime(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다.', 800);
								return;
							}
						}
					}

					//@ts-ignore
					var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
					fRows.APPROVAL_ROLE = 1;
					//@ts-ignore
					RightSheet.copyRow({row: LeftSheet.getFocusedRow()});

				   	//@ts-ignore
					RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
					//@ts-ignore
					LeftSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
				}
				
				
				
			},
		},
		//시트객체 생성
		'create':function () {
			var options = this.init.LeftSheetInit;
	
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'LeftSheet', // 생성할 시트의 id
				el: 'LeftSheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: LeftSheetData, // 생성될 시트의 정적데이터
			});
	
			var options2 = this.init.RightSheetInit;

			//@ts-ignore
			options2.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'RightSheet', // 생성할 시트의 id
				el: 'RightSheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options2, // 생성될 시트의 속성
				data: RightSheetData, // 생성될 시트의 정적데이터
			});
	
		},
		

	}	
	
    async function initSheet_modal() {
		let param = {
			"SEARCH_DIV_CD": divCd,
			"SEARCH_TEXT": searchText,
		};
		
		const response:any = await CommonUtil.execute({
            url:"http://dev.fund.win-win.or.kr/adm_7000_r002.jct",
            data: param
        })

		setREG_PERSON_ID(response.REG_PERSON_ID);
		setREG_PERSON_NM(response.REG_PERSON_NM);
		setREG_LOGIN_NM(response.REG_LOGIN_NM);
        
		if(typeof response.REC2 == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
		        
		var delItems: {code: string; name: string;}[] = [];
		// @ts-ignore
		var delItem: {code: string; name: string;} = {};

    	// @ts-ignore
		var rows = response.REC2;
		for (var i = 0; i < Object.keys(response.REC2).length; i++) {
	        delItem = {
	            code: rows[i]["CODE"],
	            name: rows[i]["NAME"],
	        };
			
 	    	delItems.push(delItem);
	  	}        
        
		setApprovalLine_S(delItems);
	
		let data_modal = response.REC;

		if(typeof data_modal == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}        
        
	   //데이터 처리
	   LeftSheetData = data_modal;
	   // @ts-ignore	
	   LeftSheet.loadSearchData(data_modal);  //data 로딩 처리 
	   // @ts-ignore	
	   LeftSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

       
	}
		
    //검색
    async function onClickSearch_modal() {
		let param = {
			"SEARCH_DIV_CD": divCd,
			"SEARCH_TEXT": searchText,
		};

		const response:any = await CommonUtil.execute({
            url:"http://dev.fund.win-win.or.kr/adm_7000_r001.jct",
            data: param
        })

		let data_modal = response.REC;

		if(typeof data_modal == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}        
        
	   //데이터 처리
	   //LeftSheetData = data_modal;
	   // @ts-ignore	
	   LeftSheet.loadSearchData(data_modal);  //data 로딩 처리 
	   // @ts-ignore	
	   LeftSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
    }; 


    async function valueChangedApprLine_modal(value) {
		console.log('value = ' + value);
		if ( value === '' ){
			setApprovalLine(value);
			setSAN_NM('');
			console.log('ok valueChangedApprLine_modal value = ' + value);
			// @ts-ignore	
			RightSheet.reloadData();
			return;
							
		} else if ( value === '선택' ){
			return;
							
		} else {
			setApprovalLine(value);
			console.log('else valueChangedApprLine_modal value = ' + value);
			let param = {
				"APPR_ID": value,
			};
			
			const response:any = await CommonUtil.execute({
	            url:"http://dev.fund.win-win.or.kr/adm_7000_r003.jct",
	            data: param
	        })
	        
			let data_modal = response.REC;
		
			if(typeof data_modal == 'undefined'){
				alert('data is not loaded!!!')
				return;
			}        
		
			//데이터 처리
			RightSheetData = data_modal;
			// @ts-ignore
			RightSheet.loadSearchData(data_modal);  //data 로딩 처리 
			// @ts-ignore	
			RightSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

		   	setSAN_NM(response.SAN_NM);
			return;
		}
	   		
	}	
	
    async function onClickSave_modal() {
		// @ts-ignore
		var delItems: { REG_LOGIN_NM: string; REG_PERSON_ID: string; SAN_PERSON_NM: string; SAN_LOGIN_NM: string; SAN_PERSON_ID: string; APPROVAL_ROLE: string; APPR_STAP_NO: string; LAST_SAN_YN: string; SAN_NM: string;}[] = [];
		// @ts-ignore
		var delItem:  { REG_LOGIN_NM: string; REG_PERSON_ID: string; SAN_PERSON_NM: string; SAN_LOGIN_NM: string; SAN_PERSON_ID: string; APPROVAL_ROLE: string; APPR_STAP_NO: string; LAST_SAN_YN: string; SAN_NM: string;} = {};


    	// @ts-ignore
		if( RightSheet.getTotalRowCount() < 1 ){
			UIUtils.alert('선택된 결재순위가 없습니다.').then();
			return;
		} 
		
		if ( SAN_NM === ''){
			var vSAN_NM = "";
			// @ts-ignore
			var rows = RightSheet.getDataRows();
			for (var i = 0; i < rows.length; i++) {
				vSAN_NM = vSAN_NM + rows[i]["PERSON_NM"];	
				if ( i !== rows.length - 1) {
					vSAN_NM = vSAN_NM + ' > ';
				}
			}
			setSAN_NM(vSAN_NM);
			var sSAN_NM = vSAN_NM;		
		} else {
			var sSAN_NM= SAN_NM;
		}			
				
        delItem = {
            APPR_STAP_NO: "0",
			REG_LOGIN_NM : REG_LOGIN_NM,
			REG_PERSON_ID : REG_PERSON_ID,
            SAN_NM: sSAN_NM,
            APPROVAL_ROLE: "0",
            SAN_LOGIN_NM: REG_LOGIN_NM,
            SAN_PERSON_ID: REG_PERSON_ID,
            SAN_PERSON_NM: REG_PERSON_NM,
            LAST_SAN_YN: "N",
        };		
		delItems.push(delItem);		
			
    	// @ts-ignore
		var rows = RightSheet.getDataRows();
		for (var i = 0; i < rows.length; i++) {
			if ( i === rows.length - 1){
		        delItem = {
		            APPR_STAP_NO: String(i+1),
					REG_LOGIN_NM : REG_LOGIN_NM,
					REG_PERSON_ID : REG_PERSON_ID,
		            SAN_NM: sSAN_NM,
		            APPROVAL_ROLE: rows[i]["APPROVAL_ROLE"],
		            SAN_LOGIN_NM: rows[i]["LOGIN_NM"],
		            SAN_PERSON_ID: rows[i]["PERSON_ID"],
		            SAN_PERSON_NM: rows[i]["PERSON_NM"],
		            LAST_SAN_YN: "Y",
		        };
			} else {
		        delItem = {
		            APPR_STAP_NO: String(i+1),
					REG_LOGIN_NM : REG_LOGIN_NM,
					REG_PERSON_ID : REG_PERSON_ID,
		            SAN_NM: sSAN_NM,
		            APPROVAL_ROLE: rows[i]["APPROVAL_ROLE"],
		            SAN_LOGIN_NM: rows[i]["LOGIN_NM"],
		            SAN_PERSON_ID: rows[i]["PERSON_ID"],
		            SAN_PERSON_NM: rows[i]["PERSON_NM"],
		            LAST_SAN_YN: "N",
		        };				
			}			
			
 	    	delItems.push(delItem);
			      	
	  	}		

		if ( delItems.length > 0 ){
			var delItems2: {code: string; name: string;}[] = [];
			// @ts-ignore
			var delItem2: {code: string; name: string;} = {};

		    if(await UIUtils.confirm('저장하겠습니까?')){
				if( ApprovalLine === '' ){
					const response:any = await CommonUtil.execute({
						url:"http://dev.fund.win-win.or.kr/adm_7000_c004.jct",
						data: { "REC" : delItems }
					})
			        // @ts-ignore
			        if(!response.COMMON_HEAD.ERROR){
						if(typeof response.REC2 == 'undefined'){
							alert('data is not loaded!!!')
							return;
						}        
				
				    	// @ts-ignore
						var rows = response.REC2;
						console.log(response.REC2);
						for (var i = 0; i < Object.keys(response.REC2).length; i++) {
					        delItem2 = {
					            code: rows[i]["CODE"],
					            name: rows[i]["NAME"],
					        };
							
				 	    	delItems2.push(delItem2);
					  	}
				        
			            UIUtils.alert('정상처리되었습니다.').then();
						//ApprovalLine_Set(delItems2, response.APPR_ID);
						setApprovalLine_S(delItems2);
						console.log("insert response.APPR_ID = " + response.APPR_ID);
		            	valueChangedApprLine_modal(response.APPR_ID);
			            return;
			        } 		        
										
				} else {
					const response:any = await CommonUtil.execute({
						url:"http://dev.fund.win-win.or.kr/adm_7000_u006.jct",
						data:  { 
							"APPR_ID" : ApprovalLine, 
							"REC" : delItems
						}
					})
			        // @ts-ignore
			        if(!response.COMMON_HEAD.ERROR){
						if(typeof response.REC2 == 'undefined'){
							alert('data is not loaded!!!')
							return;
						}        
				        
				    	// @ts-ignore
						var rows = response.REC2;
						console.log(response.REC2);
						for (var i = 0; i < Object.keys(response.REC2).length; i++) {
					        delItem2 = {
					            code: rows[i]["CODE"],
					            name: rows[i]["NAME"],
					        };
							
				 	    	delItems2.push(delItem2);
					  	}
				        
			            UIUtils.alert('정상처리되었습니다.').then();
						setApprovalLine_S(delItems2);
						console.log("update response.APPR_ID = " + response.APPR_ID);
		            	valueChangedApprLine_modal(response.APPR_ID);
			            return;
			        } 		        

				}

					
			}
		} 
		
	}
		
	const ApprovalLine_Set = (delItems2: {code: string; name: string;}[], sAPPR_ID) => {
		console.log('init : ' + setApprovalLine);
		setApprovalLine_S(delItems2);
		valueChangedApprLine_modal(sAPPR_ID);
		
		console.log('ApprovalLine_Set APPR_ID : ' + APPR_ID);
	}
	
	async function onClickDelete_modal() {
		if( ApprovalLine === '' ){
			UIUtils.alert('선택된 결재선이 없습니다.').then();
			return;
		} else {
		    if(await UIUtils.confirm('삭제하겠습니까?')){
				const response:any = await CommonUtil.execute({
					url:"http://dev.fund.win-win.or.kr/adm_7000_d005.jct",
					data: { "APPR_ID" : ApprovalLine }
				})
		
				if (!response.COMMON_HEAD.ERROR) {
					UIUtils.alert("삭제되었습니다.").then();
					var delItems2: {code: string; name: string;}[] = [];
					// @ts-ignore
					var delItem2: {code: string; name: string;} = {};
					
					if(typeof response.REC == 'undefined'){
						alert('data is not loaded!!!')
						return;
					}        
			        
			    	// @ts-ignore
					var rows = response.REC;
					console.log(response.REC);
					for (var i = 0; i < Object.keys(response.REC).length; i++) {
				        delItem2 = {
				            code: rows[i]["CODE"],
				            name: rows[i]["NAME"],
				        };
						
			 	    	delItems2.push(delItem2);
				  	}
			        
		            //UIUtils.alert(response.ERR_MSG).then();
					setApprovalLine_S(delItems2);
					setSAN_NM('');
					// @ts-ignore	
					RightSheet.reloadData();					
					return;
				}
			}		
		}
		
	}
	
	const handleSelect = (e) => {
		if(e.target.name === 'divCd'){
			setDivCd(e.taget.value);
	    }
	};
	    	
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch_modal();
		}
	}

	const rowAdd = (value) => {
		/** 행 추가 전에 중복 데이터 확인 처리 */
		//@ts-ignore
		if(RightSheet.getTotalRowCount() > 0){
			//@ts-ignore
			if(RightSheet.getTotalRowCount() > 6){
				UIUtils.alert('최대 7명까지만 결재순위에 등록할 수 있습니다.').then();
				//evtParam.sheet.showMessageTime(rightRows[i].PERSON_NM + ' 중복이름이 존재합니다.', 800);
				return;						
			}			
			//@ts-ignore
			var Rows = RightSheet.getDataRows(); //우측 시트값 전체 데이터 조회
			//@ts-ignore
            var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
            
			for(var i=0; i<Rows.length; i++){
				if(fRows.PERSON_NM === Rows[i].PERSON_NM){
					alert('중복값이 존재합니다.');
					return;
				}
			}
		}
		//@ts-ignore
		var fRows = LeftSheet.getFocusedRow();   //좌측 시트값 체크
		fRows.APPROVAL_ROLE = value;
		//@ts-ignore
		RightSheet.copyRow({row: fRows});
		//@ts-ignore
		RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		//@ts-ignore
		LeftSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
	} 	
		    	
	//결재자 위로
	const rowMoveUp = (e) => {

		// 선택된 행 객체를 얻음.
		//@ts-ignore
		var crow = RightSheet.getFocusedRow();
		if (crow) {
			//@ts-ignore
			var nrow = RightSheet.getPrevRow(crow);
			// index 기준 Row객체 얻기
			if(nrow != null){
				//@ts-ignore
				RightSheet.moveRow({row:crow, next:nrow , render:1});
				//@ts-ignore
				RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
			}

		}else{
			//@ts-ignore
			RightSheet.showMessageTime('선택된 셀이 없습니다.', 1500);
		}
	}

	//결재자 아래로
	const rowMoveDown = (e) => {
		// 선택된 행 객체를 얻음.
		//@ts-ignore
		var crow = RightSheet.getFocusedRow();
		if (crow) {
			//@ts-ignore
			var nrow = RightSheet.getNextRow(crow);
			if(nrow !=null){
				//@ts-ignore
				RightSheet.moveRow({row:nrow, next:crow , render:1});
				//@ts-ignore
				RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
			}

		}else{
			//@ts-ignore
			RightSheet.showMessageTime('선택된 셀이 없습니다.', 1500);
		}
	}
			    
	const rowDel = (e) => {
		//@ts-ignore
		RightSheet.removeRow({row:RightSheet.getFocusedRow()});
		
		//@ts-ignore
		RightSheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.

	} 
	

    async function onAfterOpen() {
        ib_modal.create();
		
	}
	
	async function onClose() {
	  setModalIsOpen(false);
	  // @ts-ignore
	  IBSheet.LeftSheet.dispose();
	  // @ts-ignore
	  IBSheet.RightSheet.dispose();
		
	}	
	
	// init 
	React.useEffect(() => {
		
		
	},[])
		
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">기금관리</a></li>
						<li className=""><a href="">지급관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">$</h1>

						{/* 실제 개발시 필요없는 버튼입니다. 삭제해주세요 */}
						<br/><br/>
						<Button color='gray' size="sm" onClick={() => setModalIsOpen(true)}>adm_7000p 열기</Button> <br /><br />
						{/* 실제 개발시 필요없는 버튼입니다. 삭제해주세요 */}				

					</main>
				</div>
			{/* modal - 7000 */}
			<ModalPopup
				open={modalIsOpen}
				title="결재선"
				size="xlg"
				onClose={() => onClose()}
				onAfterOpen={() => onAfterOpen()}
			>
				<div className="modal-con">

					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">결재선</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w400">
										<div className="hz-item hz-fg sl sl-md">
											<UISelect
									        	className=""
									        	firstName={"sel"}
									        	value={ApprovalLine}
									        	valueChanged={(value) => valueChangedApprLine_modal(value)}
									        	codeData={ApprovalLine_S}
									      	/>	
										</div>
										<Button color="gray-o" size="md" onClick={()=>onClickDelete_modal()}>삭제</Button>
									</div>

								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">결재선명</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w400">
										<UIInput type="text" className={'tf tf-md w100p'} value={SAN_NM} placeholder={''} readOnly={false} valueChanged={(value) => setSAN_NM(value)}/>
										<Button color="pri-o2" size="md" onClick={()=>onClickSave_modal()}>저장</Button>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">결재선</p>
								<div className="fo-value">
								
									<div className="approval-gen">
										<div className="approval-gen-member">
											<div className="box">
												<div className="hz-root hz-left hz-gap5 mb8">
													<div className="sl sl-sm">
													<select name="divCd" id="divCd" className="" onChange={handleSelect} value={divCd}>
														<option value="01">이름</option>
														<option value="02">아이디</option>
													</select>
													</div>
													<UIInput className={'tf tf-sm w200'} value={''} placeholder={''} valueChanged={(value) => setSearchText(value)} onKeyEnter={(e) => activeEnter(e)}/>
													<Button color="pri" size="sm" onClick={()=>onClickSearch_modal()}>검색</Button>
												</div>
												<div id ="LeftSheetDiv" className="ibsheet" ></div>
											</div>
										</div>
										<div className="approval-ctr">
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd('1')}>검토자</button>
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd('2')}>협조자</button>
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd('3')}>감사자</button>
											<button className="bt bt-right-arr" data-color="gray-o" data-size="md" type="button" onClick={()=>rowAdd('4')}>결재자</button>
										</div>
										<div className="approval-gen-selected">
											<div className="box">
												<div className="hz-root hz-sb hz-bottom mb8">
													<h2 className="hz-item tx tx-bd2">결재순위</h2>
													<div className="hz-item hz-root hz-right hz-gap5">
														<Button color="gray-o" size="sm" onClick={rowDel}>삭제</Button>
														<button className="hz-item bt bt-gray-o bt-down" type="button" onClick={rowMoveDown}>아래로</button>																						
														<button className="hz-item bt bt-gray-o bt-up" type="button" onClick={rowMoveUp}>위로</button>
													</div>																			
												</div>												
												<div id="RightSheetDiv" className="ibsheet"></div>
											</div>
											<div className="info">
													<p className="info-tit">안내</p>
													<ul className="info-list">
														<li>위에서부터 아래로 결재순서가 진행됩니다.</li>
														<li>최종결재자의 한도금액이 설정되지 않아 결재상신이 안되는 경우는 관리자에게 문의하시기 바랍니다.</li>
													</ul>
											</div>
										</div>
									</div>

								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className="ta h50 w100p">
										<textarea  className="ta-ip" placeholder=""></textarea>
									</div>
								</div>
							</div>														
							
						</div>
					</form>

				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md">취소</Button>
						<Button color='pri' size="md">결재상신</Button>
					</div>
				</div>	
			</ModalPopup>				
		</PageContainer>
	);
}
export default ContentsContainer;
